module.exports = "/_next/static/images/14ad2018aad9779edc16f4759b955fad-currency-icon.svg.webp";